import { LoadingProps } from "@common/types";
import { cn } from "@app/lib/utils";
import { Spinner, getLoadingSize } from "./Spinner";

const legacySizeMap = {
  small: "sm",
  medium: "md",
  large: "lg",
} as const;

export function Loading({
  enabled,
  type = "cover",
  size = "medium",
  rounded = true,
  className,
}: LoadingProps) {
  if (enabled === false) {
    return null;
  }

  const normalizedSize =
    typeof size === "number" ? size : legacySizeMap[size] || size;
  const actualSize = getLoadingSize(normalizedSize);

  return (
    <div
      className={cn(
        "z-10 flex justify-center overflow-hidden text-primary transition-all duration-150 ease-linear",
        type === "cover" &&
          "absolute inset-0 h-full w-full items-center bg-card/75 backdrop-blur-[1px]",
        rounded && "rounded-md",
        type === "slide" ? enabled && "mb-3" : "items-center",
        type === "block" && "my-4 min-h-20",
        className,
      )}
      style={{
        maxHeight: type === "slide" ? (enabled ? actualSize : 0) : undefined,
      }}
    >
      <Spinner size={actualSize} />
    </div>
  );
}
